import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { isDevMode } from './config/devConfig';

// Landing and Auth Components
import LandingPage from './components/landing/LandingPage';
import LoginSelection from './components/auth/LoginSelection';
import Login from './components/auth/Login';
import StudentLogin from './components/auth/StudentLogin';
import StaffLogin from './components/auth/StaffLogin';
import Register from './components/auth/Register';

// Dashboard and Application Components
import Dashboard from './components/dashboard/Dashboard';
import StudentDashboard from './components/dashboard/StudentDashboard';
import StaffDashboard from './components/dashboard/StaffDashboard';
import Stage1Form from './components/application/Stage1Form';
import Stage2Form from './components/application/Stage2Form';
import PaymentPage from './components/payment/PaymentPage';
import ApplicationReview from './components/application/ApplicationReview';

// Outing Management Components
import { 
  StudentOutingPortal, 
  ParentOutingPortal, 
  StaffOutingPortal, 
  SecurityOutingPortal 
} from './components/outing';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginSelection />} />
            <Route path="/login/parent" element={<Login />} />
            <Route path="/login/student" element={<StudentLogin />} />
            <Route path="/login/staff" element={<StaffLogin />} />
            <Route path="/register" element={<Register />} />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/student/dashboard"
              element={
                <ProtectedRoute>
                  <StudentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/staff/dashboard"
              element={
                <ProtectedRoute>
                  <StaffDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stage1"
              element={
                <ProtectedRoute>
                  <Stage1Form />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stage2"
              element={
                <ProtectedRoute>
                  <Stage2Form />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment"
              element={
                <ProtectedRoute>
                  <PaymentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/application-review"
              element={
                <ProtectedRoute>
                  <ApplicationReview />
                </ProtectedRoute>
              }
            />

            {/* Outing Management Routes */}
            <Route
              path="/outing/student"
              element={
                <ProtectedRoute>
                  <StudentOutingPortal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/outing/parent"
              element={
                <ProtectedRoute>
                  <ParentOutingPortal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/outing/staff"
              element={
                <ProtectedRoute>
                  <StaffOutingPortal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/outing/security"
              element={
                <ProtectedRoute>
                  <SecurityOutingPortal />
                </ProtectedRoute>
              }
            />

            {/* Default redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
